import { MobileSiteHeader } from './MobileSiteHeader';

export default MobileSiteHeader;
